import { type FormWithDocumentType } from '@frontend/documents-hooks';

const FORM_LINK_BASE = 'https://forms.wv3.io/form';

export const createDocumentLink = (document?: FormWithDocumentType) => {
  if (!document) return '';
  const { businessGroupIds, companyId, documentType, id } = document;
  const documentTypeQuery = (documentType === 'packet' ? 'packetId=' : 'formId=') + id;
  const companyIdQuery = companyId
    ? `&companyId=${companyId}`
    : businessGroupIds
    ? `&companyId=${businessGroupIds?.[0]}`
    : '';
  return FORM_LINK_BASE + '?' + documentTypeQuery + companyIdQuery;
};
